<template>
  <data-table :service="OrderService"
              v-show="showTable"
              :columns="columns"
              :entity="entity"
              :filters="filters"
              :sync-route="false"
              :go-to-details-on-row-click="false"
              operations=""
              @no-data="showTable = false"
              @fetch-data="onFetchData"
              ref="table">
    <template slot="table-header-left">
      <h6>{{$t('dashboard.list.orders')}}</h6>
    </template>
    <template slot="updated_at" slot-scope="{row}">
      {{$formatDate(row.updated_at, FRIENDLY_DATE_FORMAT)}}
    </template>
    <template slot="name" slot-scope="{row}">
      {{row.name}}
    </template>
    <template slot="price" slot-scope="{row}">
      {{row.price | toCurrency}}
    </template>
    <template slot="extra-buttons" slot-scope="{row, index}">
      <el-select class="select-default"
                 size="small"
                 :value="row.action || deafaultOperation"
                 @change="val => onActionChange(val, row)">
        <el-option class="select-default"
                   v-for="option in operations"
                   :key="option.value"
                   :label="option.label"
                   :value="option.value">
        </el-option>
      </el-select>
    </template>

  </data-table>

</template>
<script>
  import { Select, Option } from 'element-ui'
  import OrderService from 'src/services/OrderService'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'dashboard-order-list',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        OrderService,
        entity: entities.ORDER,
        showTable: false
      }
    },
    computed: {
      columns () {
        return this.tableColumns || [
          {
            prop: 'updated_at',
            label: this.$t('dashboard.labels.order.date'),
            sortable: true,
            minWidth: '125px'
          },
          {
            prop: 'name',
            label: this.$t('dashboard.labels.order.client'),
            sortable: true,
            minWidth: '160px'
          },
          {
            prop: 'price',
            label: this.$t('dashboard.labels.order.price'),
            sortable: true,
            minWidth: '105px'
          }
        ]
      },
      operations () {
        return [
          {
            label: this.$t('generic.verify'),
            value: 'verify'
          },
          {
            label: this.$t('generic.decline'),
            value: 'decline'
          }
        ]
      },
      deafaultOperation () {
        return this.$t('generic.view')
      },
      filters () {
        return [
          {
            key: 'match[status]',
            value: 'check'
          }
        ]
      }
    },
    methods: {
      onActionChange (val, row) {
        this.$set(row, 'action', val)
        if (val === 'verify') {
          this.verifyOrder(row)
        } else {
          this.declineOrder(row)
        }
      },
      onFetchData(response) {
        if(response.total) {
          this.showTable = true;
        }
      },
      refreshTable () {
        this.$refs.table.getTableData()
      },
      async verifyOrder (row) {
        await OrderService.orderVerify(row.uuid, {status: 'success'})
        this.refreshTable()

      },
      async declineOrder (row) {
        await OrderService.orderVerify(row.uuid, {status: 'blocked'})
        this.refreshTable()
      }
    }
  }
</script>
<style>
</style>


